


























































import Vue from "vue";
export default Vue.extend({
  data() {
    return {
        btnshow:false,
        showType: 0
    };
  },
  components: {},
  watch: {},
  mounted() {},
  methods: {
    handleConfirm() {
        this.btnshow = false
    },
    showDialog (type:any) {
        this.btnshow = true
        this.showType = type
    },
    getTitle (type:any) {
        switch (type) {
            case 1:
                return this.$t('headerFoot.contactUstip1')
            case 2:
                return this.$t('headerFoot.contactUstip2')
            case 3:
                return this.$t('headerFoot.contactUstip3')
            default:
                return ''
        }
    }
  },
  beforeDestroy() {}
});
